import React, { lazy, Suspense } from 'react'
import LoadingComponent from 'components/generic/LoadingComponent'

const LazyComponent = lazy(() => import(/* webpackChunkName: "verify" */ './'))

export default function VerifyLazy(props) {
  return (
    <Suspense fallback={<LoadingComponent />}>
      <LazyComponent {...props} />
    </Suspense>
  )
}
